import React, { useEffect } from "react";
import './user-role.scss';
import UserRoleLayout from "../../components/layout/UserRole";
import { useDataContext } from "../../hooks/useDataContext";
import Loading from "../../components/compound/Loader";

const UserRole = () => {
  const { data, loading } = useDataContext();
  
  // The data from context is already the assigned object: { inquiry: [], tasks: [] }
  // API structure: { status: 200, data: { tasks: { assigned: { tasks: [], inquiry: [] } } } }
  // This is set in dataContext.js line 131: payload: response?.data?.tasks?.assigned
  const officePartnerData = data || null;
  
  console.log('UserRole - data from context:', data);
  console.log('UserRole - officePartnerData:', officePartnerData);

  useEffect(() => {
    // Add class to body when component mounts
    document.body.classList.add('user-role-page');

    // Remove class from body when component unmounts
    return () => {
      document.body.classList.remove('user-role-page');
    };
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <UserRoleLayout officePartnerData={officePartnerData} />
    </>
  );
};

export default UserRole;

